import { success } from './success'
import { error } from './error'
import { info } from './info'
import { player } from './player'
import { warning } from './warning'

export const feedbotToast = { success, error, info, player, warning }
